module.exports = __webpack_public_path__ + "img/_ic_checkbox_off.e86c4aa9.svg";